import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPeople2"><Path d="M6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5Z" fill="currentColor"/><Path d="M3.49474 21C3.2186 21 3 20.7761 3 20.5V18.5C3 16.0147 5.01472 14 7.5 14H16.5C18.9853 14 21 16.0147 21 18.5V20.5C21 20.7761 20.7814 21 20.5053 21C17.9109 21 6.08912 21 3.49474 21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeople2;
